import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAdmin } from '../context/admin';

/**
 * Bloquea el render de las páginas /admin/* a menos que el backend confirme
 * que el usuario es admin. Es sólo UX: la data sensible la protege
 * require_admin en el backend. Mientras resuelve muestra un spinner; si no es
 * admin, redirige al home.
 */
export const AdminGuard: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isAdmin, loading } = useAdmin();

  if (loading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spin />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to='/' replace />;
  }

  return <>{children}</>;
};
